var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.stack
    ? _c("i", {
        staticClass: "fa",
        class: "fa-" + _vm.name + " " + _vm.extraClasses + " " + _vm.iconClass,
        attrs: { "aria-hidden": "true" },
        on: {
          click: function ($event) {
            return _vm.$emit("click", $event)
          },
        },
      })
    : _c("span", { staticClass: "fa-stack fa-lg" }, [
        _c("i", {
          staticClass: "fa fa-stack-2x",
          class: "fa-" + _vm.name + " " + _vm.iconClass,
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-stack-1x fa-inverse",
          class: "fa-" + _vm.stackIconName + " " + _vm.stackIconClass,
          attrs: { "aria-hidden": "true" },
        }),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }